export const isObject = (value: any) => {
  const type = typeof value
  return value != null && (type === "object" || type === "function")
}

export const markStates = (
  sobj: Record<string, any>,
  self: Record<string, any>,
) => {
  if (!isObject(sobj)) {
    throw new Error("mark: invalid sobj, exepect a object")
  }
  const selfKeys = Object.keys(self)

  Object.entries(sobj)?.forEach(([key, val]) => {
    if (!selfKeys.includes(key)) return false
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!Array.isArray(val) && isObject(val) && self[key] !== null) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, no-param-reassign
      self[key] = Object.assign(self[key], val)
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, no-param-reassign
      self = Object.assign(self, { [key]: val })
    }
  })

  return false
}

export const capitalize = (_string: string) =>
  _string.slice(0, 1).toUpperCase() + _string.slice(1)

// Promises to wait for the specified property to become available.
export const waitFor = (
  propertyPath: string, // path of the property to wait for
  timeout = 5000, // maximum time to wait before rejecting
  interval = 50, // time interval between checks for the prperty
) => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now()

    const checkProperty = () => {
      const propertyValue = propertyPath.split(".").reduce(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (obj, key) => (obj && obj[key] !== undefined ? obj[key] : undefined),
        window,
      )

      if (propertyValue !== undefined) {
        resolve(propertyValue)
      } else if (Date.now() - startTime >= timeout) {
        reject(new Error(`Timeout waiting for ${propertyPath}`))
      } else {
        setTimeout(checkProperty, interval)
      }
    }
    checkProperty()
  })
}
